// extracted by mini-css-extract-plugin
module.exports = {"divider-h":"Divider_divider-h__Hoo3D","divider-v":"Divider_divider-v__kfseG"};